// Application Info

<template>
<div class="lms5010 container white curved">

  <div class="board content-box">
    <!-- <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><span aria-current="page">Parcel</span></li>
    </Ul> -->

    <div class="p-3 lams curved-top">
      <p class="page-title serif bold mb-0"><i class="fa fa-file-text-o fa-lg ml-1 mr-2"></i>Application Info</p>
    </div>

    <div class="app-info" v-if="!isMapEnabled">
      <table>
        <tbody class="lg-1">
          <tr>
            <td class="w-40 info-label">Application Number</td>
            <td class="w-60 bold">{{ app.applicationNumber }}</td>
          </tr>
          <tr>
            <td class="w-50 info-label">Lot Number</td>
            <td class="w-50 bold">{{ app.lotNumber }}</td>
          </tr>
          <tr>
            <td class="w-50 info-label">Location</td>
            <td class="w-50 bold">{{ app.locationName }}</td>
          </tr>
          <tr>
            <td class="w-50 info-label">Area</td>
            <td class="w-50 bold">{{ core.toDecimalFormat(app.area) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="info-map mt-2" v-if="isMapEnabled">

      <sym-card class="lams-light shadow-light border-main m-0" headerClass="p-0">
        <p class="mb-2">Application Number<span> <h5>{{ app.applicationNumber }}</h5></span></p>
        <p class="mb-2">Lot Number<span><h5>{{ app.lotNumber }}</h5></span></p>
        <p class="mb-2">Location<span><h5>{{ app.locationName }}</h5></span></p>
        <p class="mb-2">Area: <span><h5>{{ core.toDecimalFormat(app.area) }}</h5></span></p>
      </sym-card>

      <div class="map-container">
        <!-- public folder -->
        <img src="img/map.png" class="map w-100 h-100 shadow-light border-main curved" @click="showMap()">
        <span class="map-view-label pos-middle badge beige border-dark lg-3 p-2" @click="showMap()">View Map</span>
      </div>

    </div>

    <div class="text-center my-3">
      <button type="button" class="cart-button success text-center lg-2" @click="showCart()" :disabled="!hasItem"><i class="fa fa-shopping-cart fa-lg mr-2"></i>Cart ({{ cartItems.length }}) </button>
    </div>

    <p class="box-border lams lg-3 p-2" v-show="appDocuments && appDocuments.length" >Downloadable Documents</p>

    <div class="documents">
      <sym-card class="whitesmoke shadow-light border-main m-0" headerClass="p-0" v-for="(d, index) in appDocuments" :key="index">

        <div class="ml-1">
          <p class="lg-3 bold mb-1">{{ d.imageTypeName }}</p>
        </div>

        <div class="ml-1" v-for="p in itemPrices" :key="p.imageTypeId" >
          <span v-show="p.imageTypeId === d.imageTypeId">PHP {{ core.toDecimalFormat(p.price) }} </span>
        </div>

        <div class="buttons w-100 justify-between mt-2" justify-between mb-0 shadow-soft>
          <button type="button" class="success-light border-main fw-26" @click="loadImage(d)"><i class="fa fa-image mr-2"></i>Preview</button>
          <button type="button" class="success border-main fw-32 mr-0" v-if="!isInCart(d)" @click="addToCartClick(d)"><i class="fa fa-shopping-cart mr-2"></i>Add to cart</button>
          <button type="button" class="primary-light border-main fw-32 mr-0" @click="onToggleItemSelection(d)" v-if="isInCart(d)"><i class="fa fa-remove mr-2"></i>Remove</button>
        </div>

      </sym-card>
    </div>

    <div class="d-flex justify-center align-items-center danger-light border-main p-2 curved" v-if="isListLoaded && appDocuments && appDocuments.length === 0">
      <span class="lg-2"><i class="fa fa-info-circle fa-lg mr-2"></i>No documents found.</span>
    </div>

    <button type="button" class="primary text-center w-100 lg-1 shadow mt-3 mb-2" @click="goBack()"><i class="fa fa-arrow-left mr-2"></i> Back</button>

    <sym-modal
      v-model="isModalVisible"
      size="sm"
      :header="true"
      :customBody="true"
      :footer="false"
      :keyboard="true"
      :dismissible="true"
      title="<p class='mb-0 lg-3 bold ml-1'>Preview</p>"
      v-if="isModalVisible"
      headerClass=""
      dismissButtonClass=""
      @show="onShowPreview"
      @hide="onHidePreview"
    >
      <div class="board p-0 mb-0">

        <div class="p-2 lams-dark curved border-lightgray m-0">
          <p class="lg-3 mb-0"><i class="fa fa-file-image-o fa-lg ml-1 mr-2"></i>{{ this.documentName }}</p>
        </div>

        <p class="beige p-2 mb-0 text-center">
          Image quality in Preview mode is poor. Paid version of this document is in the best quality possible.
        </p>

        <div class="pos-relative">
          <div class="glass" ref="glass" v-if="isGlassEnabled">
          </div>
          <img :src="dom.getImageSource(document.blob)" class="w-100 d-block" ref="docimage">
        </div>

        <div slot="footer" class="p-2">
          <button type="button" class="primary text-center w-100 lg-1 shadow mb-0" @click="isModalVisible = false"><i class="fa fa-arrow-left mr-2"></i> Back</button>
        </div>
      </div>
    </sym-modal>

  </div>

</div>
</template>

<script>

import {
  get
} from '../../js/http';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms4010',

  data () {
    return {
      regionId: 0,
      applicationId: 0,
      app: [],
      appDocuments: [],

      document: {},
      isModalVisible: false,
      isCartModalVisible: false,
      documentName: '',
      cartKey: '',
      cartItems: [],
      itemPrices: [],
      price: 0,
      totalPrice: 0,
      showByIndex: null,

      isListLoaded: false

    };
  },

  computed: {

    hasItem () {
      if (this.cartItems.length > 0) {
        return true;
      }
    },

    glassImageUrl () {
      if (!this.document) { return ''; }
      return "url('" + this.dom.getImageSource(this.document.blob) + "')";
    }

  },

  methods: {

    loadImage (d) {
      const
        me = this,
        wait = me.wait();

      me.getDocumentImage(d).then(
        info => {
          me.document = info[0];
          me.documentName = d.imageTypeName;
          me.stopWait(wait);
          me.isModalVisible = true;
        }
      );

    },

    getTargetPath () {
      const
        me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      if (me.applicationId) {
        q.applicationId = me.applicationId;
      }

      return {
        name: me.$options.name,
        query: q
      };
    },

    syncValues (p, q) {
      const me = this;

      if ('regionId' in q && me.core.isInteger(q.regionId)) {
        me.regionId = parseInt(q.regionId);
      }

      if ('applicationId' in q && me.core.isInteger(q.applicationId)) {
        me.applicationId = parseInt(q.applicationId);
      }

    },

    loadData () {
      const
        me = this,
        wait = me.wait();

      me.getApplication()
        .then( info => {
          me.app = info.app[0];
          me.stopWait(wait);
          me.replaceUrl();
          return me.getApplicationDocuments();
        })
        .then( info => {
          me.appDocuments = info.documents;
          me.isListLoaded = true;
        })
        .catch( fault => {
          me.stopWait(wait);
          me.showFault(fault);
        });

    },

    calculateTotal () {
      const me = this;

      let total = 0;
      me.cartItems.forEach((item) => {
        total += item.price;
      });

      me.totalPrice = total;
    },

    removeAll () {
      const me = this;

      me.cartItems = [];
      me.removeLocalItem(me.cartKey);
      me.isCartModalVisible = false;
    },

    showMap () {
      const me = this;

      if (me.app && !me.app.surveyId) {
        me.dialog.warning('Map is not available.');
        return;
      }

      let route = {
        name: 'lms5020',
        params: {
          regionId: me.regionId,
          parcelId: me.app.parcelId,
          surveyId: me.app.surveyId
        }
      };
      this.go(route);
    },

    showCart () {
      const me = this;

      let route = {
        name: 'lms5030',
        params: {
          regionId: me.regionId
        }
      };
      this.go(route);
    },

    isItemSelected (item) {
      return this.cartItems.findIndex(obj => obj.imageId === item.imageId && obj.entityId === item.entityId && obj.datasourceId === item.datasourceId) > -1;
    },

    onToggleItemSelection (item) {
      const
        me = this,
        index = me.cartItems.findIndex(obj => obj.imageId === item.imageId && obj.entityId === item.entityId && obj.datasourceId === item.datasourceId);

      if (index > -1) {
        me.cartItems.splice(index, 1);
      }

      me.removeLocalItem(me.cartKey);
      me.setLocalItem(me.cartKey, me.cartItems);
      me.calculateTotal();
    },

    addToCartClick (itemCart) {
      const
        me = this,
        wait = me.wait();

      let o = {};

      o.datasourceId = itemCart.datasourceId;
      o.entityId = itemCart.entityId;
      o.imageId = itemCart.imageId;
      o.imageFormatId = itemCart.imageFormatId;
      o.imageTypeName = itemCart.imageTypeName;
      o.imageTypeId = itemCart.imageTypeId
      o.accountId = itemCart.accountId
      o.price = me.getItemPrice(itemCart);

      if (!this.isInCart(o)) {
        me.cartItems.push(o)
        me.setLocalItem(me.cartKey, me.cartItems);
        me.stopWait(wait);
      }

      me.stopWait(wait);

    },

    getItemPrice (index) {
      const
        me = this;

      let item = me.itemPrices.find( i => i.imageTypeId === index.imageTypeId);
      return item.price;
    },

    isInCart (item) {
      const me = this;

      let index = me.cartItems.find( i => i.imageId === item.imageId && i.entityId === item.entityId && i.datasourceId === item.datasourceId);
      return index;
    },

    getLocalStorage () {
      const me = this;
      let info = me.getLocalItem(me.cartKey);

      if (info) {
        me.cartItems = info;
      }
    },

    // API calls

    getApplication () {
      return get('api/rgn/' + this.regionId + '/applications/' + this.applicationId + '/info');
    },

    getApplicationDocuments () {
      return get('api/rgn/' + this.regionId + '/applications/' + this.applicationId + '/documents');
    },

    getItemPrices () {
      return get('api/item-prices/' + this.regionId);
    },

    getDocumentImage (d) {
      const
        regionId = this.regionId,
        datasourceId = d.datasourceId,
        entityId = d.entityId,
        imageId = d.imageId,
        imageFormatId = d.imageFormatId;

      let q = 'datasourceId=' + datasourceId;

      q = q + '&entityId=' + entityId;
      q = q + '&imageId=' + imageId;
      q = q + '&imageFormatId=' + imageFormatId;

      return get('api/rgn/' + regionId + '/documents?' + q);
    },

    // helpers

    getCursorPosition (e) {
      let
        rect,
        x = 0,
        y = 0,
        evt = e || window.event,
        img = this.$refs.docimage;

      let pos = { x: x, y: y };

      if (!img) { return pos; }

      rect = img.getBoundingClientRect();

      x = evt.pageX - rect.left;
      y = evt.pageY - rect.top;

      x = x - window.pageXOffset;
      y = y - window.pageYOffset;

      pos.x = x;
      pos.y = y;

      return pos;
    },

    onGlassMove (e) {
      const
        me = this,
        img = me.$refs.docimage,
        glass = me.$refs.glass;

      if (!img) { return; }
      if (!glass) { return; }

      let
        pos, x, y, w, h, bw = 3,
        zoom = me.previewZoom;

      const style = glass.style;

      // e.preventDefault();

      pos = me.getCursorPosition(e);
      x = pos.x;
      y = pos.y;

      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;

      if (x > img.width - (w / zoom)) { x = img.width - (w / zoom); }
      if (x < w / zoom) { x = w / zoom; }
      if (y > img.height - (h / zoom)) { y = img.height - (h / zoom); }
      if (y < h / zoom) { y = h / zoom; }

      // set glass position

      style.left = (x - w) + 'px';
      style.top = (y - h) + 'px';

      // show what's under the glass

      style.backgroundPosition = '-' + ((x * zoom) - w + bw) + 'px -' + ((y * zoom) - h + bw) + 'px';
    },

    onShowPreview () {
      const
        me = this,
        zoom = me.previewZoom,
        glass = me.$refs.glass,
        img = me.$refs.docimage;

      if (!me.isGlassEnabled) { return; }

      glass.style.backgroundImage = this.glassImageUrl;
      glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";

      if (glass) {
        me.dom.on(glass, 'mousemove', me.onGlassMove);
        me.dom.on(glass, "touchmove", me.onGlassMove);
      }

      if (img) {
        me.dom.on(img, 'mousemove', me.onGlassMove);
        me.dom.on(img, 'touchmove', me.onGlassMove);
      }

    },

    onHidePreview () {
      const
        me = this,
        glass = me.$refs.glass,
        img = me.$refs.docimage;

      if (!me.isGlassEnabled) { return; }

      if (glass) {
        me.dom.off(glass, 'mousemove', me.onGlassMove);
        me.dom.off(glass, "touchmove", me.onGlassMove);
      }

      if (img) {
        me.dom.off(img, 'mousemove', me.onGlassMove);
        me.dom.off(img, 'touchmove', me.onGlassMove);
      }
    }

  },

  created () {
    this.previewZoom = 2;
    this.isGlassEnabled = true;
    this.isMapEnabled = false;
  },

  mounted () {
    const me = this;

    me.syncValues(me.params, me.query);

    me.getItemPrices().then(
      info => {
        if (info) {
          me.itemPrices = info;
        }
      },
      fault => {
        me.showFault(fault);
      }
    );

    me.cartKey = me.sym.userInfo.accountCode + '*' + me.regionId + '*CART';

    me.getLocalStorage();
    me.loadData();

  }

}

</script>

<style scoped>

.lms4010 {
  min-height: calc(100vh - 90px - 2rem) ;
}

.page-title {
  font-size: 1.25rem;
}

.info-label {
  text-align: right;
  background-color: #e4f5f1;
}

.app-info td {
  vertical-align: top;
}

.info-map {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 16rem;
  gap: 1rem;
}

.map-container {
  position: relative;
}

.map-view-label {
  opacity: 0.8;
}

.map-view-label:hover {
  cursor: pointer;
}

.map {
  opacity: 0.75;
  object-fit: cover;
  object-position: center;
  max-height: 16rem;
}

.map:hover {
  cursor: pointer;
  opacity: 1;
}

.cart-button {
  width: 32.6%;
}

.documents {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.glass {
  position: absolute;
  border: 4px solid crimson;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  cursor: none;
}

@media (max-width: 1250px) {
  .documents {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 900px) {
  .content-box {
    padding: .75rem;
  }

  .info-map {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(auto-fit, 16rem);
  }
}

@media (max-width: 740px) {
  .documents {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .lms4010 {
    min-height: calc(100vh - 84px) ;
  }
}

@media (max-width: 480px) {
  .cart-button {
    width: 100%;
  }
}

@media (max-width: 320px) {
  .documents >>> .card-body {
    padding: .5rem;
  }
}

</style>